import { createRouter, createWebHistory } from 'vue-router';
import Login from '../views/Login.vue';
import Receiver from '../views/Receiver.vue';

const routes = [
  {
    path: '/',
    redirect: '/login'  // 默认跳到登录页
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/receiver',
    component: Receiver
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
